import orderBy from 'lodash/orderBy';
import get from 'lodash/get';

export default function trierListe(list, property, sens) {
  if (!Array.isArray(list) || list.length === 0) return list;

  const listWithProperty = list.filter(item => get(item, property));
  const listWithoutProperty = list.filter(item => !get(item, property));

  const sortedList = orderBy(listWithProperty, [property], [sens]);

  return [...sortedList, ...listWithoutProperty];
}
